module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Ow80Au/tc-custom/9781781264577.jpg?1729082748527",
      "alt": "This image is the cover for the book Twenty to Crochet: Crocheted Flowers to Wear, Twenty to Make"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Twenty to Crochet: Crocheted Flowers to Wear, Twenty to Make\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This lovely book provides 20 contemporary, stylish designs for crocheted corsages – large, eye-catching floral designs that can be worn in different ways: as a brooch, buttonhole, on your wrist, shoes, bag or belt, for example. The flowers are made in a variety of sizes and styles, with different types of flower, all worked in various colours, yarns and crochet stitches. Some feature added embellishments such as buttons and beads.    Some of the flowers are based on real ones, such as the pansy, lily and hydrangea, while others, such as spectrum, roux and rainbow are fantasy flowers designed by Anna. There is more variety in that some of the flowers are quite flat, while others are distinctly 3-D, giving them added appeal. The patterns are easy to follow and there is a beautiful photograph of each one, suggesting ways of wearing them.     All of the materials used are widely available both here and in the US. Examples of the author's work can be found on her website, www.moochka.co.uk.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anna Nikipirowicz\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Search Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0